/**
 * Supported cryptocurrencies for SEO internal linking.
 * Slugs must match backend seo_currencies.slug (ProgrammaticSeoSeeder).
 */
export interface SeoCurrency {
  symbol: string;
  name: string;
  slug: string;
}

export const SEO_CURRENCIES: SeoCurrency[] = [
  { symbol: 'USDT', name: 'Tether USD', slug: 'usdt' },
  { symbol: 'USDC', name: 'USD Coin', slug: 'usdc' },
  { symbol: 'BTC', name: 'Bitcoin', slug: 'bitcoin' },
  { symbol: 'ETH', name: 'Ethereum', slug: 'ethereum' },
  { symbol: 'TRX', name: 'TRON', slug: 'trx' },
  { symbol: 'BNB', name: 'BNB', slug: 'bnb' },
  { symbol: 'MATIC', name: 'Polygon', slug: 'matic' },
  { symbol: 'SOL', name: 'Solana', slug: 'sol' },
];

export function currencyGatewayPath(slug: string): string {
  return `/page/${slug}-payment-gateway`;
}

export function currencyGatewayLabel(currency: SeoCurrency): string {
  return `${currency.name} (${currency.symbol}) Payment Gateway`;
}
